import React from "react"
import { BLOCKS, MARKS } from "@contentful/rich-text-types"
import { documentToReactComponents } from "@contentful/rich-text-react-renderer"
import { makeStyles } from "@material-ui/styles"

const useStyles = makeStyles(theme => {
  return {
    bold: { fontWeight: "bold" },
    italic: { fontStyle: "italic" },
    text: props => ({
      display: "inline",
      fontSize:
        props.copyText && props.copyText.fontSize
          ? parseInt(props.copyText.fontSize)
          : 20,
      fontFamily:
        props.copyText && props.copyText.fontFamily
          ? props.copyText.fontFamily
          : ["Proxima Nova", "Roboto", "Helvetica", "Arial", "sans-serif"].join(
              ","
            ),
      fontWeight:
        props.copyText && props.copyText.fontWeight
          ? parseInt(props.copyText.fontWeight)
          : 400,
      letterSpacing:
        props.copyText && props.copyText.letterSpacing
          ? props.copyText.letterSpacing
          : "0px",
      lineHeight:
        props.copyText && props.copyText.lineHeight
          ? props.copyText.lineHeight
          : "32px",
      textTransform: props.copyText && props.copyText.textTransform,
      color:
        props.copyText && props.copyText.fontColor
          ? props.faq
            ? props.open
              ? theme.palette.black.main
              : props.copyText.fontColor
            : props.copyText.fontColor
          : theme.palette.black.main,
      marginTop: "0px",
      marginBottom: "0px",
    }),
    link: { color: theme.palette.green.main },
    underline: {
      textDecoration: "underline",
    },
  }
})
const RichDescription = props => {
  const classes = useStyles(props)

  const Bold = ({ children }) => (
    <span className={classes.bold}>{children}</span>
  )
  const Italic = ({ children }) => (
    <span className={classes.italic}>{children}</span>
  )
  const Text = ({ children }) => <p className={classes.text}>{children}</p>
  const Link = ({ children }) => (
    <span className={classes.link}>{children}</span>
  )
  const Underline = ({ children }) => (
    <span className={classes.underline}>{children}</span>
  )

  const options = {
    renderMark: {
      [MARKS.BOLD]: text => <Bold>{text}</Bold>,
      [MARKS.ITALIC]: text => <Italic>{text}</Italic>,
      [MARKS.UNDERLINE]: text => <Underline>{text}</Underline>,
    },
    renderNode: {
      [BLOCKS.PARAGRAPH]: (node, children) => <Text>{children}</Text>,
      [BLOCKS.HYPERLINK]: (node, children) => <Link>{children}</Link>,
    },
  }

  return (
    <React.Fragment>
      {props.copyText.content
        ? documentToReactComponents(props.copyText.content.json, options)
        : documentToReactComponents(props.copyText.json, options)}
    </React.Fragment>
  )
}

export default RichDescription
